'use client';

import React, { useMemo, useCallback } from 'react';
import { useRefinementList } from 'react-instantsearch';
import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';
import useAdvancedSearchContext from '../../hooks/useAdvancedSearchContext';

const ClearAllFiltersButtonComponent = () => {
  const {
    isReadyToShipActive,
    handleToggleReadyToShip,
    minWidth,
    maxWidth,
    handleWidthChange,
  } = useAdvancedSearchContext();

  const { items, refine } = useRefinementList({ attribute: 'type' });

  const hasActiveProductTypes = useMemo(
    () => items?.some(item => item.isRefined) || false,
    [items]
  );

  const hasActiveWidth = useMemo(() => !!(minWidth || maxWidth), [
    minWidth,
    maxWidth,
  ]);

  const hasActiveFilters = useMemo(
    () => isReadyToShipActive || hasActiveWidth || hasActiveProductTypes,
    [isReadyToShipActive, hasActiveWidth, hasActiveProductTypes]
  );

  const handleClearAll = useCallback(() => {
    // Reset Ready to Ship
    if (isReadyToShipActive) {
      handleToggleReadyToShip?.(false);
    }

    // Reset Width filter
    if (hasActiveWidth) {
      handleWidthChange?.('', '');
    }

    // Reset Product Types
    if (hasActiveProductTypes) {
      refine([]);
    }
  }, [
    isReadyToShipActive,
    handleToggleReadyToShip,
    hasActiveWidth,
    handleWidthChange,
    hasActiveProductTypes,
    refine,
  ]);

  if (!hasActiveFilters) {
    return null;
  }

  return (
    <div className="md:pb-5">
      <ClearAllFiltersButton onClick={handleClearAll}>
        Clear all
      </ClearAllFiltersButton>
    </div>
  );
};

export default ClearAllFiltersButtonComponent;
